import React from 'react';
import { ArrowDownIcon as ArrowDown } from '@heroicons/react/20/solid';
import tw from 'twin.macro';
import { EllipsisHorizontalIcon as DotsHorizontal } from '@heroicons/react/20/solid';
import { Menu } from 'components/Menu';
import { useTranslation } from 'react-i18next';

interface Props {
  onChange: (v: { fieldName: string; direction: 'ASC' | 'DESC' }) => void;
  direction: 'ASC' | 'DESC';
  fieldName: string;
  fieldLabel: string;
  portal?: boolean;
}

export function SortButton(props: Props) {
  const { direction, fieldLabel, fieldName, onChange } = props;
  const { t } = useTranslation(['eleve']);

  return (
    <div tw="inline-flex items-center gap-x-0.5">
      <div
        onClick={() =>
          onChange({
            direction: direction === 'ASC' ? 'DESC' : 'ASC',
            fieldName,
          })
        }
        tw="text-muted text-xs font-semibold tracking-tight mb-0 py-1 hover:bg-neutral-quiet inline-flex rounded-lg items-center gap-x-1 px-2 -ml-2 cursor-pointer"
      >
        {fieldLabel}{' '}
        <ArrowDown
          css={[
            tw`transform transition-transform duration-200 h-3 w-3 text-brand-intense`,
            direction === 'DESC' && tw`rotate-0`,
            direction === 'ASC' && tw`rotate-180`,
          ]}
        />
      </div>
      <div
        css={[
          tw`w-0.5 h-3 bg-neutral-moderate rounded-lg`,
          `
            width: 1px;
          `,
        ]}
      />
      <div>
        <Menu portal>
          <Menu.Button small minimal tw="px-0! py-1.5! inline-flex! min-h-0">
            <DotsHorizontal tw="text-muted h-3 w-3" />
          </Menu.Button>
          <Menu.Items size="auto">
            <Menu.Item
              onClick={() =>
                onChange({
                  direction,
                  fieldName: 'givenName',
                })
              }
              text={<div>{t('eleve:fields.givenName')}</div>}
            />
            <Menu.Item
              onClick={() =>
                onChange({
                  direction,
                  fieldName: 'familyName',
                })
              }
              text={<div>{t('eleve:fields.familyName')}</div>}
            />
          </Menu.Items>
        </Menu>
      </div>
    </div>
  );
}
